if ($("footer#footer").length) {
  $("#signature a:first").prepend("<span>Vytvořil</span>");
  $("#signature a:eq(1)").text("Shoptet");
  $("#signature").append('<span>| <a href="https://www.d2solutions.cz/?utm_source=webdesign&amp;utm_campaign=klasek" target="_blank">D2 Solutions</a></span>');
  $("#signature").append('<span>| <a href="https://www.shopcode.cz/?utm_source=kodovani&amp;utm_campaign=klasek" target="_blank" >Shopcode</a></span>');

  $("body.in-index").length ? $(".homepage-box.welcome-wrapper").before($("#footer .pekarna").clone()) : $("footer#footer").before($("#footer .pekarna").clone());

  $(".overall-wrapper").append($("#footer .reviews").clone());
  $(".overall-wrapper").append($("#footer .instagramFeed").clone());
  $(".instagram-widget>a").each(function () {
    $(".instagramFeed .igFeed").append('<div class="igPost"><a href="' + $(this).attr("href") + '" target="_blank" style="background-image: url(' + $(this).find("img").attr("data-src") + ')"></a></div>');
  });

  $(document).on("click", ".custom-footer > div .h4", function () {
    const parent = $(this).closest(".custom-footer > div");
    const wasOpen = parent.hasClass("openIt");
    $(".custom-footer > div").removeClass("openIt");

    if (!wasOpen) {
      parent.addClass("openIt");
    }
  });

  $("footer#footer .customSocials").append($("footer#footer .contact-box li span.facebook").closest("li"), $("footer#footer .contact-box li span.instagram").closest("li"));

  $(".superContact").append($("footer#footer .contact-box li span.tel").closest("li").clone().addClass("tel"));
  $(".superContact").append($("footer#footer .contact-box li span.mail").closest("li").clone().addClass("mail"));

  if ($(".id-719").length) {
    $(".contactRow .telFirst").append($("footer#footer .contact-box li span.tel").closest("li").clone().addClass("tel"));
    $(".contactRow .mail span").html("").append($("footer#footer .contact-box li span.mail").closest("li").clone().addClass("mail"));
  }
  $('footer#footer').after($('footer#footer .mobileReservationDate'))
}


